export default __webpack_public_path__ + "static/media/user-line-green.957621a8.svg";